import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '../lib/utils'

interface Props {
  page: number
  totalPages: number
  onChange: (page: number) => void
  /** 현재 페이지 양옆으로 보여줄 개수 */
  siblings?: number
}

const BTN = 'inline-flex size-9 items-center justify-center rounded-lg text-sm font-medium disabled:opacity-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40'

export function Pagination({ page, totalPages, onChange, siblings = 1 }: Props) {
  if (totalPages <= 1) return null

  const start = Math.max(1, page - siblings)
  const end = Math.min(totalPages, page + siblings)
  const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i)

  return (
    <nav className="flex items-center justify-center gap-1" aria-label="페이지">
      <button className={cn(BTN, 'text-slate-500')} onClick={() => onChange(page - 1)} disabled={page <= 1}>
        <ChevronLeft className="size-4" />
        <span className="sr-only">이전</span>
      </button>

      {start > 1 && (
        <>
          <button className={cn(BTN, 'text-slate-600')} onClick={() => onChange(1)}>1</button>
          {start > 2 && <span className="px-1 text-slate-400">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          aria-current={p === page ? 'page' : undefined}
          className={cn(BTN, p === page ? 'bg-primary font-bold text-white' : 'text-slate-600')}
          onClick={() => onChange(p)}
        >
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-slate-400">…</span>}
          <button className={cn(BTN, 'text-slate-600')} onClick={() => onChange(totalPages)}>{totalPages}</button>
        </>
      )}

      <button className={cn(BTN, 'text-slate-500')} onClick={() => onChange(page + 1)} disabled={page >= totalPages}>
        <ChevronRight className="size-4" />
        <span className="sr-only">다음</span>
      </button>
    </nav>
  )
}
